import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeKe';
const args = {};

export class ModeKe extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
